const $win = $(window);
const $doc = $(document);
const $body = $('body');
const $main = $('.main');
const $nav = $('.sidebar__nav');
const $dropdownTrigger = $('.js-trigger');
const $links = $('.sidebar__nav ul ul a');
const $sections = $('.section--features-alt');
const $features = $('.feature-alt');

let scrollTop = 0;
let activeTop = scrollTop + $('.header').outerHeight();

let timer = null;
let click = false;

if (document.location.hash !== '') {
	let $activeSection = $(document.location.hash).closest('.section--features-alt');
	$activeSection.addClass('is-active');
	changeActiveSection('#' + $activeSection.attr('id'));
	changeActiveState(document.location.hash);
} else {
	let $firstSection = $('.section--features-alt:first-of-type');
	let $firstFeature = $firstSection.find('.feature-alt:first-of-type');

	changeActiveSection('#' + $firstSection.attr('id'));
	changeActiveState('#' + $firstFeature.attr('id'));
}

$win.on('load resize orientationchange scroll', function() {
	scrollTop = $doc.scrollTop();
	activeTop = scrollTop + $('.header').outerHeight();

	$sections.each(function() {
		let top = $(this).offset().top;
		let bottom = top + $(this).outerHeight();

		if (top <= activeTop && bottom >= activeTop && !$body.hasClass('is-scrolling')) {
			let id = '#' + $(this).attr('id');

			if (!$(id).hasClass('is-active')) {
				changeActiveSection(id);
			}

			$(id)
				.addClass('is-active')
				.siblings()
				.removeClass('is-active');
		}
	});

	$features.each(function() {
		let top = $(this).offset().top;
		let bottom = top + $(this).outerHeight();

		if (top <= activeTop && bottom >= activeTop && !$body.hasClass('is-scrolling')) {
			let id = '#' + $(this).attr('id');
			changeActiveState(id);
		}
	});
});

$('.js-sidebar-trigger').on('click', function(e) {
	e.preventDefault();

	$('.js-sidebar-trigger')
		.add($('.js-scroll-container'))
		.toggleClass('is-active');
});

$dropdownTrigger.on('click', function(e) {
	e.preventDefault();

	const id = $(this).attr('href');

	scrollToSection(id, 10);

	$(this)
		.next()
		.slideToggle()
		.parent()
		.toggleClass('expanded')
		.siblings()
		.removeClass('expanded')
		.find('ul')
		.slideUp();
});

$links.on('click', function(e) {
	e.preventDefault();
	$body.addClass('is-scrolling');

	let id = $(this).attr('href');

	changeActiveSection(id);
	changeActiveState(id);
	scrollToSection(id);

	$('.js-sidebar-trigger')
		.add($('.js-scroll-container'))
		.removeClass('is-active');
});

function changeActiveSection(id) {
	let $activeSection = $(id);
	let $linkParent = $('a[href="' + id + '"]').parent();
	let $dropdownFirstElements = $linkParent.find('li:first-child');

	if ($activeSection.length > 0 && $activeSection.offset().top <= activeTop) {
		$dropdownFirstElements.addClass('is-active');
	}

	if (!$linkParent.hasClass('expanded')) {
		$linkParent
			.addClass('expanded')
			.find('ul')
			.slideDown()
			.find('li:first-child')
			.parent()
			.closest('li')
			.siblings()
			.removeClass('expanded')
			.find('ul')
			.slideUp();
	}
}

function changeActiveState(id) {
	$links.each(function() {
		$(this)
			.parent()
			.removeClass('is-active');
	});

	$nav.find('a[href="' + id + '"]')
		.parent()
		.addClass('is-active');
}

function scrollToSection(id, buffer = 0) {
	$('html, body').animate(
		{
			scrollTop: $(id).offset().top - $('.header').outerHeight() + buffer,
		},
		200
	);
}

window.addEventListener(
	'scroll',
	function() {
		if (timer !== null) {
			clearTimeout(timer);
		}
		timer = setTimeout(function() {
			$body.removeClass('is-scrolling');
		}, 150);
	},
	false
);
